enum ScheduledTaskStateType {
  RUNNING,
  PAUSED,
}

export default ScheduledTaskStateType;
